import { render } from "./reportOrderBill.vue?vue&type=template&id=4b9de8ba"
import script from "./reportOrderBill.vue?vue&type=script&lang=js"
export * from "./reportOrderBill.vue?vue&type=script&lang=js"

import "./reportOrderBill.vue?vue&type=style&index=0&id=4b9de8ba&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__